import React from 'react';
import ionOpenOutline from '../../../../assets/Quotes/ionOpenOutline.svg';
import ionOpenOutlineHsb from '../../../../assets/Quotes/Horizon/ion_open-outline.svg';
import { isHorizon } from '../../../../utils/brandHelper';

const HowDoThesePlansWork = props => {
  const icon = isHorizon ? ionOpenOutlineHsb : ionOpenOutline

  return (
    <div className={`howDoThesePlansWork fs-18 d-flex align-items-center justify-content-between ${props.className} fw-600`} onClick={()=> props.togglePlanModal()}>        
      How do these plans work?
      <img src={icon} />
  </div>
  );
};

export default HowDoThesePlansWork;
